import Vue from "vue";
import Vuex from "vuex";
// import VueCookies from "vue-cookies";
import axios from "axios";

Vue.use(Vuex);

const isEmpty = obj => {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
};

export default new Vuex.Store({
  state: {
    // endpoint: "",
    // endpoint: "/api/sys/",
    // endpoint: "http://test.artkoch.ru",
    endpoint: "https://etuus.com/api/sys",
    requestCommonParams: {
      headers: { "content-type": "application/json" },
      withCredentials: true
    },

    isLoggedIn: false,

    urlPathLogin: "/login",
    // urlLogin: "/sys/login",
    loginProgress: false,
    loginError: false,

    urlLogout: "/logout",
    urlPathGroups: "/groups",
    urlCreateGroup: "/groups",
    urlUpdateGroup: "/update-group",
    urlDeleteGroup: "/delete-group",
    urlCreateIds: "/create-id",
    createIdsProgress: false,

    getMemberQuizResultsLoading: false,
    getMemberQuizResultsError: false,

    allGroupsList: [
      {
        name: "Загрузка...",
        description: "",
        id: 0
      }
    ],
    allMembersList: [],
    allQuizzesList: [],

    // currentGroupId: "",
    memberQuizResults: {},
    currentMember: {},
    currentGroup: {
      name: "Загрузка...",
      description: "",
      id: 0
    },
    currentMemberQuizzes: {},

    globalErr: "",

    psyTypeText: [
      [
        "Вы собраны, размеренны, вдумчивы, стремитесь делать то, что Вы делаете, как можно лучше. В связи с разнообразностью подходов к разным видам деятельности Вам необходим индивидуальный подход со стороны преподавателя.",
        "Для Вас крайне важно постоянное подтверждение результата в процессе обучения.",
        "Соответственно, Вам больше подойдут задания на результат, то есть определяющие, демонстрирующие и подтверждающие уровень знаний и степень прогресса.",
        "Объем домашних заданий для Вас оптимальнее средний, состоящий из творческих и интеллектуальных заданий."
      ],
      [
        "Вы собраны, размеренны, вдумчивы, стремитесь делать то, что Вы делаете, как можно лучше, даже с оттенком перфекционизма. В связи с разнообразностью подходов к разным видам деятельности Вам необходим индивидуальный подход со стороны преподавателя.",
        "Скорее, не командный игрок, не очень любите соревновательность, сравнения и критику.",
        "В обучении Вам важно подтверждение результата и прогресса, с одной стороны, и достаточно конкретные задания, с другой.",
        "Пример конкретного задания: со “словами в скобках” и написанием верной грамматической формы или в виде текста с пропусками для внесения верного варианта из предложенных.",
        "Объем домашнего задания рекомендуется средний, с чередованием конкретных заданий с творческими и интеллектуальными заданиями."
      ],
      [
        "Вы с лёгкостью беретесь за любое дело, многозадачность Вас не пугает, но Вы нередко нуждаетесь в чьей-либо поддержке.",
        "Предпочтительно разнообразить процесс обучения, как совместный с преподавателем, так и самостоятельный во время выполнения домашнего задания. Допустима прозрачная система оценки достижений.",
        "Оптимальна максимальная визуализация процесса с большим количеством разговорных упражнений."
      ],
      [
        "То, что Вы делаете, Вы делаете очень хорошо, но не всегда получается сконцентрировать внимание и правильно распределить ресурсы. Для Вас чаще важнее сам процесс, нежели результат. Возможно, присутствуют высокая отвлекаемость и быстрое переключение интереса.",
        "Вы не любите длинные рутинные однообразные упражнения, требующие усидчивости и предельно высокой концентрации внимания.",
        "Соответственно, и домашнее задание рекомендуется небольшое и разнообразное.",
        "Оптимальна максимальная визуализация процесса с большим количеством разговорных упражнений."
      ],
      [
        "Вы перфекционист, чаще скрупулезно подходите к выполнению любой задачи. Скорее, не командный игрок, не очень любите соревновательность, сравнения и критику.",
        "Вы чувствуете отдачу, если нужно “копать много, глубоко и тщательно”.",
        "Для Вас больше подойдут задания с высокой степенью конкретики - например, со “словами в скобках” и написанием верной грамматической формы или в виде текста с пропусками для внесения верного варианта из предложенных. ",
        "Возможно выполнение и большого объёма д/з, ориентированного на чтение и письмо."
      ]
    ],
    communicativeSkillsDescription: {
      involvement: [
        "Способность удерживать внимание и понимать предмет обсуждения",
        "От 8 до 10 баллов – быстро обрабатывает и усваивает сложную информацию, коммуникация может проходить ускоренно - более емкие по содержанию тексты и более сложные блоки информации.",
        "От 5 до 7 баллов – средняя способность к усвоению и обработке информации. Для комфортной коммуникации с таким человеком необходимо предельно лаконично и ясно выражать свою мысль, не торопиться в коммуникации. Одно предложение – одна мысль.",
        "От 2 до 4 баллов – сложно обрабатывать входящую информацию, нужно постепенное погружение в тему. При общении с таким человеком старайтесь после каждой мысли задавать вопрос или каким-то другим образом подтверждать, что человек все еще вас слушает. Присутствует высокая отвлекаемость, малейшая перегрузка информацией может привести к полной “потери связи”. "
      ],
      clarity: [
        "Ясность речи и мыслей",
        "От 8 до 10 баллов – высокая способность излагать свои мысли ясно, высокая ясность мышления. Легко обнаруживает неясность речи собеседника и предъявляет к речи собеседника высокие требования. При общении с таким человеком надо выражаться предельно ясно и контролировать каждое слово.",
        "От 5 до 7 баллов – средняя способность излагать свои мысли ясно.",
        "От 2 до 4 баллов – низкая способность излагать свои мысли ясно, что может свидетельствовать о путанице в мыслях. В общении с таким человеком нужно сфокусироваться на понимании, а не на изложении."
      ],
      awareness: [
        "понимание своей позиции и целей речи",
        "От 8 до 10 баллов – высокое осознание своей позиции и целей речи, трудно переубедить или сбить с толку. Такой человек привык использовать и воспринимать логические аргументы. Имеет сильную позицию и может ее логически обосновать.",
        "От 5 до 7 баллов – эпизодические осознание позиции и концентрация на целях речи. Необходимо убедиться, что человек имеет позицию и может ее обосновать.",
        "От 2 до 4 баллов – низкое осознание своей позиции и целей речи, легко сбить с толку или переубедить. На такого человека хорошо действуют психологические аргументы. Зачастую такой человек не вдумывается в ситуацию. Как правило, если даже позиция есть - обосновать ее логически человек не может."
      ],
      mental_flexibility: [
        "Cпособность подстраиваться под разные ситуации и придерживаться правил",
        "От 8 до 10 баллов – легко переключается между предметами в рамках одного обсуждения. Если такой человек “ушел в сторону”, обычно достаточно намека для возвращения на нужный предмет.",
        "От 5 до 7 баллов – трудно переключаться с предмета на предмет в рамках одного обсуждения. Таким образом, при общении с таким человеком сложно “сменить волну” на нужную. Нужно четко фиксировать, о каком предмете в данный момент думает человек. Если переключение предмета произошло плавно - человек может задержаться на предыдущем, что создаст трудности в коммуникации.",
        "От 2 до 4 баллов – нахождение “на своей волне”, переключение между разными предметами крайне сложно. При общении с таким человеком нельзя резко возвращать его к предмету разговора при уходе в сторону. Нужно встраиваться в волну человека и вылавливать точки переключения на нужный предмет."
      ],
      anxiety: [
        "Уверенность – позитивная оценка своих навыков и способностей как достаточных для достижения целей",
        "От 8 до 10 баллов – высокая оценка своих навыков и способностей, высокая решительность действий, не всегда есть осторожность в действиях. Есть риск принятия необдуманных и плохо взвешенных решений. Возможно, нужно разъяснить ситуации, в которых требуется осторожность при принятии решений.",
        "От 5 до 7 баллов – эпизодические трудности в принятии решении, высокая осторожность. Необходимо понять, насколько часто возникают эпизоды неуверенности и с чем они связаны. Если дело в страхе ошибок - действовать по принципам из предыдущего пункта.",
        "От 2 до 4 баллов – негативная оценка своих навыков и способностей, трудно принимать решения. Нужно создавать ситуации принятия решения и поддерживать после принятия. Желательно вначале создавать ситуации, где все возможные решения - позитивные. Затем продемонстрировать, что даже ошибочное решение - лучше чем никакое. Необходимо убедить, проявлять осторожность нужно, но отказываться от решений из-за страха ошибки - нельзя."
      ]
    },
    memberQuizBarCharts: {},
    barGraphInitialData: [
      {
        label: "Включенность",
        name: "involvement",
        value: 5,
        color: ["#FFDE7F", "rgba(255, 185, 104, 0.1)"]
      },
      {
        label: "Осознанность",
        name: "awareness",
        value: 5,
        color: ["#00D7A2", "rgba(0, 215, 162, 0.1)"]
      },
      {
        label: "Ясность",
        name: "clarity",
        value: 5,
        color: ["#FF026F", "rgba(255, 2, 111, 0.1)"]
      },
      {
        label: "Гибкость мышления",
        name: "mental_flexibility",
        value: 5,
        color: ["#2792FF", "rgba(39, 146, 255, 0.1)"]
      },
      {
        label: "Уверенность",
        name: "anxiety",
        value: 5,
        color: ["#FFB967", "rgba(255, 185, 103, 0.1)"]
      }
    ],
    membersQuizzes: {},
    getMembersQuizzesLoading: false,
    getMembersQuizzesError: false
  },
  mutations: {
    setGlobalErr(state, m) {
      state.globalErr = m;
    },
    setLogin(state, payload) {
      state.isLoggedIn = payload;
    },
    toggleLogInOut(state) {
      state.isLoggedIn = !state.isLoggedIn;
    },
    setAllIdData(state, payload) {
      state.allIdsData = payload;
    },
    setLoginReqStat(state, [name, stat]) {
      state[`login${name}`] = stat;
    },
    setAllGroupsList(state, payload) {
      state.allGroupsList = payload;
    },
    setReqStat(state, [name, stat]) {
      state[name] = stat;
    },
    setCurrentGroup(state, payload) {
      state.currentGroup = payload;
    },
    setMemberQuizzes(state, payload) {
      state.membersQuizzes = {
        ...payload
      };
    },
    getCurrentGroup({ allGroupsList }, p) {
      allGroupsList.map(o => {
        if (o.id === p.id) {
          o.name = p.name;
          return o;
        }
      });
    },
    setAllMembersList(state, p) {
      state.allMembersList = p;
    },
    setCurrentMember(state, p) {
      state.currentMember = p;
    },
    setMemberQuizResults(state, p) {
      state.memberQuizResults = {
        ...state.memberQuizResults,
        ...p
      };
    },
    updateBarGraphValues(state, p) {
      const id = p[0];
      const values = p[1];

      const chart = values;
      //  state.barGraphInitialData.map((o, i) => {
      //   o.value = values[i][o.name];
      //   console.log("state.barGraphInitialData", state.barGraphInitialData);
      //   console.log("o", o);
      //   console.log("o.value", o.value);
      //   console.log("values[i][o.name]", values[i][o.name]);
      //   return o;
      // });

      console.log("chart", chart);
      state.memberQuizBarCharts = {
        [id]: chart
      };
      // console.log("stqwd ", {
      //   [id]: chart
      // });
      // console.log("state.memberQuizBarCharts ", state.memberQuizBarCharts);
    },
    getMembersQuizzesLoading(state, p) {
      state.getMembersQuizzesLoading = p;
    },
    getMembersQuizzesError(state, p) {
      state.getMembersQuizzesError = p;
    }
  },
  getters: {
    getInArray: state => (array, key, value) =>
      array.filter(o => o[key] == value)[0],

    getUrl: ({ endpoint }) => path => `${endpoint + path}`,
    urlLogin: (state, { getUrl }) => getUrl(state.urlPathLogin),
    urlGroups: (state, { getUrl }) => getUrl(state.urlPathGroups),

    urlAllMembers: ({ currentGroup }, { urlGroups }) => id =>
      `${urlGroups}/${id || currentGroup.id}/members`,

    urlAllIds: ({ urlPathGroups }) => groupId =>
      `${urlPathGroups}/${groupId}/members`,

    getGroup: ({ allGroupsList }) => id => {
      const result = allGroupsList.filter(g => g.id === id);
      console.log("result", result[0]);
      return result[0];
    }
  },
  actions: {
    async login({ state, commit, getters }, data) {
      const { requestCommonParams } = state;
      const { urlLogin } = getters;

      const p = {
        ...requestCommonParams
      };

      try {
        const r = await axios.post(urlLogin, JSON.stringify(data), p);
        commit("setLogin", true);
        return r;
      } catch (err) {
        throw err;
      }
    },

    async getAllGroups({ state, commit, getters, dispatch }) {
      const { requestCommonParams, currentGroup } = state;
      const { urlGroups } = getters;

      const params = {
        ...requestCommonParams,
        method: "get",
        url: urlGroups,
        transformResponse: [
          data => JSON.parse(data).sort((a, b) => a.id - b.id)
        ]
      };

      try {
        const r = await axios(params);
        await commit("setAllGroupsList", r.data);
        await dispatch("getAllMembers", currentGroup.id);

        return r.data;
      } catch (err) {
        throw err;
      }
    },

    async getAllMembers({ state, commit, getters }, id) {
      const { requestCommonParams } = state;
      const { urlAllMembers } = getters;

      const params = {
        ...requestCommonParams,
        method: "get",
        url: urlAllMembers(id)
      };

      try {
        const r = await axios(params);
        commit("setAllMembersList", r.data);

        return r.data;
      } catch (err) {
        throw err;
      }
    },

    async getMemberQuizzesResult({ state, commit, getters, dispatch }, id) {
      const { requestCommonParams } = state;
      const { urlAllMembers } = getters;

      const params = {
        ...requestCommonParams,
        method: "get",
        url: `${urlAllMembers()}/${id}/quizzes`
      };

      try {
        const r = await axios(params);
        let quizzes = {};

        r.data.map(o => {
          quizzes[o.id] = {
            ...o,
            psyType: null,
            commSkillsBar: null
          };
        });

        const getMemberResult = r.data.map(async o => {
          const result = await dispatch("getMemberQuizResults", o.id);
          quizzes[o.id] = {
            ...quizzes[o.id],
            ...result[o.id]
          };
        });
        await Promise.all(getMemberResult);

        commit("setMemberQuizzes", quizzes);

        return r.data;
      } catch (err) {
        throw err;
      }
    },

    async getMemberQuizResults({ state, commit, getters }, id) {
      const { requestCommonParams } = state;
      const { urlAllMembers } = getters;

      const params = {
        ...requestCommonParams,
        method: "get",
        url: `${urlAllMembers()}/${state.currentMember.id}/quizzes/${id}`
      };

      try {
        commit("getMembersQuizzesLoading", true);
        const raw = await axios(params);
        const ptype = !isEmpty(raw.data)
          ? raw.data.img_quiz.psy_type || raw.data.img_quiz.psy_type == 0
          : null;
        let quizzes;
        let barGraphSkillValues;
        let data = !isEmpty(raw.data) ? raw.data : null;

        if (data) {
          barGraphSkillValues = state.barGraphInitialData.map(o => {
            const setMin = (n, min) => (n < min ? min : n);
            const floor = n => Math.floor(n * 10);
            o.value = setMin(floor(raw.data.text_quiz[o.name]), 2);
            return o;
          });
        }

        quizzes = {
          ...quizzes,
          [id]: {
            psyType: ptype,
            commSkillsBar: barGraphSkillValues || null
          }
        };
        commit("getMembersQuizzesLoading", false);

        return quizzes;
      } catch (err) {
        commit("getMembersQuizzesLoading", false);
        commit("getMembersQuizzesError", true);
        throw err;
      }
    },

    async createMember(
      { state, dispatch, getters },
      p = { id: null, amount: 1 }
    ) {
      const { requestCommonParams } = state;
      const { urlAllMembers } = getters;

      const params = {
        ...requestCommonParams,
        method: "post",
        url: urlAllMembers(p.id),
        data: {
          amount: p.amount
        }
      };

      try {
        const r = await axios(params);
        await dispatch("getAllMembers");

        return r.data;
      } catch (err) {
        throw err;
      }
    },

    async createGroup({ state, getters, commit, dispatch }, data) {
      const { requestCommonParams } = state;
      const { urlGroups } = getters;

      const params = {
        ...requestCommonParams,
        method: "post",
        url: urlGroups,
        data: JSON.stringify(data)
      };

      try {
        const response = await axios(params);
        const newAllGroupsList = await dispatch("getAllGroups");
        const newCurrentGroup = newAllGroupsList.filter(
          g => g.id == response.data.id
        );

        commit("setCurrentGroup", newCurrentGroup[0]);
        dispatch("getAllMembers", newCurrentGroup.id);
        // commit("setCreateListSuccess", true);

        return response.data;
      } catch (err) {
        throw err;
      }
    },

    updateGroup(
      {
        getters: { urlGroups },
        state: { currentGroup }
      },
      data
    ) {
      return axios
        .patch(`${urlGroups}/${currentGroup.id}`, {
          description: "",
          name: data
        })
        .then(r => {
          return r;
        })
        .catch(err => {
          throw err;
        });
    },

    deleteGroup({ state: { endpoint, urlDeleteGroup } }) {
      const url = `${endpoint}${urlDeleteGroup}`;
      return axios.post(url);
    },

    getAllIds({ state, commit, getters }, groupId) {
      const { requestCommonParams } = state;
      const { getUrl, urlAllIds } = getters;

      commit("setReqStat", ["getAllIdsProgress", true]);

      return axios
        .get(getUrl(urlAllIds(groupId)), requestCommonParams)
        .then(r => {
          commit("setReqStat", ["getAllIdsProgress", false]);
          commit("setAllIdData", r.data);
        })
        .catch(err => {
          throw err;
        });
    },

    createIds({ state, dispatch, commit, getters }, payload) {
      const { requestCommonParams } = state;
      const { getUrl, urlAllIds } = getters;

      const data = {
        amount: payload.amount
      };
      console.log("payload", payload);
      // commit("setCreateIdsStatus", ["Progress", true]);
      // commit("setReqStat", ["getAllIdsProgress", true]);
      return axios
        .post(getUrl(urlAllIds(payload.groupId)), data, requestCommonParams)
        .then(r => {
          dispatch("getAllIds", payload.groupId);
          // commit("setReqStat", ["getAllIdsProgress", false]);
          // commit("setCreateIdsStatus", {
          //   name: "Success",
          //   status: true
          // });
          return r;
        })
        .catch(err => {
          console.error(err);
          // commit("setCreateIdsStatus", {
          //   name: "Error",
          //   status: true
          // });
          // commit("setCreateIdsStatus", {
          //   name: "Progress",
          //   status: false
          // });
          throw err;
        })
        .finally(() => {
          // commit("setCreateIdsStatus", {
          //   name: "Success",
          //   status: false
          // });
          // commit("setCreateIdsStatus", {
          //   name: "Error",
          //   status: false
          // });
          // commit("setCreateIdsStatus", {
          //   name: "Progress",
          //   status: false
          // });
        });

      // const { endpoint, urlCreateIds } = state;

      // axios.get(url);
    }
  }
});
